import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
} from "@/components/molecules/responsive-dialog";
import { Button } from "@/components/ui/button";
import { DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { PhoneChallenge } from "@/views/login/challenges/phone";
import { useTranslation } from "@/features/utils/i18n";

interface AddPhoneDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: (preSignedToken: string) => void;
  /**
   * Prove a number already on the account rather than add one: the primary
   * typed at sign-up. Same code, same endpoint — the server records the proof
   * instead of adding a duplicate.
   */
  verifyPhone?: string;
}

export const AddPhoneDrawer = ({
  open,
  onOpenChange,
  onSuccess,
  verifyPhone,
}: AddPhoneDrawerProps) => {
  const { t } = useTranslation();

  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent className="sm:max-w-md">
        <ResponsiveDialogHeader>
          <DialogTitle>
            {verifyPhone
              ? t("security.phoneNumbers.verifyTitle")
              : t("security.phoneNumbers.addTitle")}
          </DialogTitle>
          <DialogDescription>
            {verifyPhone
              ? t("security.phoneNumbers.verifyDescription")
              : t("security.phoneNumbers.addDescription")}
          </DialogDescription>
        </ResponsiveDialogHeader>

        <PhoneChallenge
          // A fresh form per purpose: the pre-filled number is read once.
          key={verifyPhone || "add"}
          initialPhone={verifyPhone}
          onSuccess={(preSignedToken) => {
            onSuccess(preSignedToken);
            onOpenChange(false);
          }}
        />

        <ResponsiveDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("common.cancel")}
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};
